// Helpers for movie moderation_info logic.
// Manual exclusions auto-expire 1 year after the admin clicked "exclude" —
// the assumption is that today's new release is tomorrow's revival, so an
// exclusion shouldn't last forever.

export const EXCLUSION_EXPIRATION_DAYS = 365;

/**
 * Returns true if the movie is currently excluded AND that exclusion is
 * still within its expiration window.
 *
 * - moderationInfo missing or no decision → false (not excluded)
 * - decision !== 'exclude' → false
 * - exclusion timestamp missing → false (treat as expired so legacy
 *   exclusions from before reviewedAt was tracked surface again)
 * - exclusion older than EXCLUSION_EXPIRATION_DAYS → false (expired)
 * - otherwise true (still excluded, still hide the movie)
 */
export function isExclusionActive(moderationInfo, expirationDays = EXCLUSION_EXPIRATION_DAYS) {
  if (!moderationInfo || moderationInfo.decision !== 'exclude') return false;
  if (!moderationInfo.reviewedAt) return false;
  const ageMs = Date.now() - new Date(moderationInfo.reviewedAt).getTime();
  return ageMs < expirationDays * 24 * 60 * 60 * 1000;
}
